import { useEffect, useState } from "react";
import { toast } from "sonner";
import { useAuthedGet } from "@/pages/Admin";

export const UsersPanel = () => {
  const req = useAuthedGet();
  const [data, setData] = useState({ roles: [], users: [] });
  const load = () => req("/users").then((r) => setData(r.data)).catch(() => {});
  useEffect(() => { load(); }, []); // eslint-disable-line

  const change = async (user_id, role) => {
    try {
      await req(`/users/${user_id}/role`, { method: "patch", data: { role } });
      toast.success("Szerep frissítve");
      load();
    } catch (e) { toast.error(e.response?.data?.detail || "Hiba"); }
  };

  return (
    <div className="rounded-3xl border border-white/10 bg-[#1A152E] p-4" data-testid="admin-users-panel">
      <p className="mb-4 text-sm text-muted-foreground">Bejelentkezett fiókok. Az „admin” szerepűek látják a beszélgetéseket.</p>
      {data.users.map((u) => (
        <div key={u.user_id} className="flex items-center justify-between border-t border-white/5 py-3" data-testid={`admin-user-row-${u.user_id}`}>
          <span className="text-sm font-semibold">{u.email || u.user_id}</span>
          <select value={u.role} onChange={(e) => change(u.user_id, e.target.value)} data-testid="admin-user-role-select"
            className="rounded-full border border-white/10 bg-[#241E3D] px-3 py-1.5 text-sm">
            {data.roles.map((r) => <option key={r} value={r}>{r}</option>)}
          </select>
        </div>
      ))}
    </div>
  );
};
